import { KForm, KPasswordCreateField, KPasswordField } from "kinnect-general";

export default KForm.extend( {
	name: "KAccountSettingsPasswordForm",

	props: {
		formTitle: {
			...KForm.options.props.formTitle,
			default: "Change Password"
		},

		redirect: {
			...KForm.options.props.redirect,
			default: () => ( { name: "account" } )
		},

		submitButtonText: {
			...KForm.options.props.submitButtonText,
			default: "Change Password"
		}
	},

	data: () => ( {
		formFields: {
			oldPassword: null,
			password: null
		}
	} ),

	computed: {
		userID() {
			return this.$store.getters["auth/userID"];
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: `users/${this.userID}/password`,
				data: this.formFields,
				method: "patch"
			}}
			on={this.$listeners}
		>
			<KPasswordField
				label="Current Password*"
				prependIcon="lock"
				required
				vModel={this.formFields.oldPassword}
				validationName="current password"
				validationRules="required"
			></KPasswordField>

			<KPasswordCreateField
				label="New Password*"
				prependIcon="lock"
				required
				vModel={this.formFields.password}
				validationName="new password"
				validationRules="required"
			></KPasswordCreateField>
		</KForm>;
	}
} );
